// Copyright (c) 2018 Deere & Company

import {translate} from '../../../shared/services/translation-service';

export const getPartRequestsColumns = () => ({
    listColumns: [
        {
            id: 'partRequest',
            key: translate('PART_REQUEST')
        },
        {
            id: 'requestType',
            key: translate('REQUEST_TYPE')
        },
        {
            id: 'claim',
            key: translate('CLAIM')
        },
        {
            id: 'workOrder',
            key: translate('WORK_ORDER')
        },
        {
            id: 'dtacCaseNumber',
            key: translate('DTAC_CASE_NUMBER')
        },
        {
            id: 'pin',
            key: translate('PIN')
        },
        {
            id: 'partNumber',
            key: translate('PART_NUMBER')
        },
        {
            id: 'description',
            key: translate('DESCRIPTION')
        },
        {
            id: 'quantity',
            key: translate('QUANTITY')
        },
        {
            id: 'requested',
            key: translate('REQUESTED')
        },
        {
            id: 'changed',
            key: translate('CHANGED')
        },
        {
            id: 'daysLeft',
            key: translate('DAYS_LEFT')
        },
        {
            id: 'dealerLocation',
            key: translate('DEALER_LOCATION')
        },
        {
            id: 'address',
            key: translate('ADDRESS')
        },
        {
            id: 'partRequestStatus',
            key: translate('PART_REQUEST_STATUS')
        },
        {
            id: 'firstShipToLocation',
            key: translate('FIRST_SHIP_TO_LOCATION')
        },
        {
            id: 'secondShipToLocation',
            key: translate('SECOND_SHIP_TO_LOCATION')
        }
    ],
    listId: 'partRequests'
});



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/part-requests-excel-columns.js